import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import PhoneNumberInput from 'react-phone-number-input';
import { connect } from 'react-redux';
import Flow from 'flow';
import Loading from 'flow/components/ui-components/Loading';
import BaseInput from 'flow/components/ui-components/BaseInput';
import { getOwnExtensionKey, getOwnContact } from 'flow/selectors/selectors';
import { getCountryCode } from 'flow/utils/extension-utils';
import AppContext from 'flow/contexts/app-context';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var InputComponent = /*#__PURE__*/React.forwardRef(function InputComponent(props, ref) {
  var value = props.value,
    onChange = props.onChange;
  return /*#__PURE__*/_jsx(BaseInput, {
    value: value,
    onChange: onChange,
    ref: ref,
    noMarginTop: true
  });
});
InputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};
var InviteColleague = /*#__PURE__*/function (_React$PureComponent) {
  function InviteColleague(props) {
    var _this;
    _classCallCheck(this, InviteColleague);
    _this = _callSuper(this, InviteColleague, [props]);
    _defineProperty(_this, "handleChange", function (number) {
      _this.setState({
        number: number
      });
      _this.props.updateNumber(number);
    });
    _this.state = {
      number: props.number ? '' : props.number
    };
    return _this;
  }
  _inherits(InviteColleague, _React$PureComponent);
  return _createClass(InviteColleague, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        contact = _this$props.contact,
        loggedInCustomer = _this$props.loggedInCustomer;
      var number = this.state.number;
      var i18next = this.context.i18next;
      if (!loggedInCustomer) {
        return /*#__PURE__*/_jsx(Loading, {});
      }
      var countryCode = getCountryCode(contact, loggedInCustomer).toUpperCase();
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "mb-1",
          children: i18next.t('InviteColleagues.TokenField.Title')
        }), /*#__PURE__*/_jsx(PhoneNumberInput, {
          placeholder: i18next.t('InviteColleagues.TokenField.Input'),
          value: number,
          defaultCountry: countryCode,
          onChange: this.handleChange,
          countries: ['SE', 'DK', 'NO', 'GB', 'FI', 'BR', 'IT', 'ES', 'PL', 'BE', 'GR', 'BG', 'CH', 'IL', 'LV', 'LT', 'AU', 'EE', 'CL', 'PE', 'FO'],
          inputComponent: InputComponent
        })]
      });
    }
  }]);
}(React.PureComponent);
_defineProperty(InviteColleague, "propTypes", {
  number: PropTypes.string,
  updateNumber: PropTypes.func.isRequired,
  contact: Flow.PropTypes.contactDTO,
  loggedInCustomer: Flow.PropTypes.customerDTO
});
_defineProperty(InviteColleague, "contextType", AppContext);
var mapStateToProps = function mapStateToProps(state) {
  var customer = state.customer;
  var extensionKey = getOwnExtensionKey(state);
  var contact = getOwnContact(state);
  var loggedInCustomer = customer.get(extensionKey);
  return {
    contact: contact,
    loggedInCustomer: loggedInCustomer
  };
};
export default connect(mapStateToProps)(InviteColleague);